import { render } from "./Footer.vue?vue&type=template&id=370f503a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=370f503a&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f503a"]])

export default __exports__